/** Tenant api-gateway port in local dev (see backend/tenant/api-gateway/.env). */
export const LOCAL_API_GATEWAY_PORT = 8000;

/** Customer SPA port in local dev (see frontend/customer angular.json). */
export const LOCAL_CUSTOMER_PORT = 4202;

/** Tenant subdomain from the browser hostname (e.g. sbi.localhost → sbi). */
export function resolveTenantSubdomainFromHost(): string | null {
  if (globalThis.window === undefined) return null;
  const parts = globalThis.location.hostname.split('.');
  if (parts.length >= 2 && parts[0] !== 'localhost' && parts[0] !== 'www') {
    return parts[0];
  }
  return null;
}

/** Customer SPA origin using the same hostname as the admin portal (e.g. sbi.localhost:4202). */
export function resolveLocalCustomerFrontendUrl(): string {
  if (globalThis.window === undefined) {
    return `http://localhost:${LOCAL_CUSTOMER_PORT}`;
  }
  const { protocol, hostname } = globalThis.location;
  return `${protocol}//${hostname}:${LOCAL_CUSTOMER_PORT}`;
}

/**
 * Build api-gateway base URL for local dev using the current browser hostname.
 * e.g. sbi.localhost:4201 → http://sbi.localhost:7000/api/v1
 * Avoids the ng serve proxy (which fails when the gateway is not running).
 */
export function resolveLocalApiBaseUrl(): string {
  if (globalThis.window === undefined) {
    return `http://localhost:${LOCAL_API_GATEWAY_PORT}/api/v1`;
  }
  const { protocol, hostname } = globalThis.location;
  return `${protocol}//${hostname}:${LOCAL_API_GATEWAY_PORT}/api/v1`;
}

export function resolveLocalWsBaseUrl(): string {
  if (globalThis.window === undefined) {
    return `http://localhost:${LOCAL_API_GATEWAY_PORT}`;
  }
  const { protocol, hostname } = globalThis.location;
  return `${protocol}//${hostname}:${LOCAL_API_GATEWAY_PORT}`;
}
